// This file is auto-generated by @hey-api/openapi-ts
import { client as _heyApiClient } from "./client.gen";
/**
 * Device id validation.
 * Validates the device id for registration.
 */
export const disInventoryItemCodeValidation = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/devices/validation/{code}" }, options));
};
/**
 * Processes event 'consumer_canceled' event sent from CAS.
 * Anonymizes the customer and unregisters all inventory items.
 */
export const consumerCanceled = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/webhooks/consumer_canceled" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Gets the Device
 * Provides detailed information about a specific Device where all Device relevant properties are resulted,<br>
 * but no any telemetry data is resulted.
 */
export const getDisInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/devices/{code}" }, options));
};
/**
 * Gets all Devices of the user
 * Provides detailed information about all registered Devices for the authenticated user, where all<br>
 * Device relevant properties are resulted, but no any telemetry data is resulted.
 */
export const getDisInventoryItemForUser = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/devices" }, options));
};
/**
 * Registers the Device
 * Register a new Device using the specified Device ID and Display Name. The device must be a real existing<br>
 * identified by ID and not be registered to any other User at the time of request.
 */
export const diSv1RegisterInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/devices" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Removes consumer device registration.
 * Removes consumer device registration using the Consumer Id.<br>
 * The device must be registered with the same Consumer ID.
 */
export const unregisterInventoryItemForConsumer = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/devices/{code}/unassign" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Registers the Device in guest registration mode
 * Register a new Device using the specified Device ID and Display Name<br>
 * The device must be a real existing identified by ID and not be registered to any other User at the time of request.
 */
export const registerInventoryItemForGuest = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/devices/guest" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Removes guest device registration.
 * Removes guest device registration using the specified Device Id.<br>
 * The device must not have consumer id assigned to it.
 */
export const unregisterInventoryItemForGuest = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/devices/guest/{code}/unassign" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Assign the consumer to the Device
 * Assign the consumer to the Device to complete device registration flow.<br>
 * Device must be registered by guest before calling this endpoint.
 */
export const assignCustomerToInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/devices/{code}/consumer" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Gets the Device's registration history
 * Provides information about the registrations of a specific Device.
 */
export const getDeviceRegistrationHistory = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/devices/{code}/history" }, options));
};
/**
 * Register Product to set up inventory and get warranty
 * Register Product to set up inventory and get warranty
 */
export const productRegister = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/products/register" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get details of limits per product type for logged user
 * Get details of limits per product type for logged user
 */
export const userDetails = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/me" }, options));
};
/**
 * Register Product for logged User / Customer
 * Register Product for logged User / Customer
 */
export const meProductRegister = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/me/products/register" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get list of all product prefixes from storage.
 * Okta scopes for S2S authorization: inventory
 */
export const getProductPrefixes = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/product-prefixes" }, options));
};
/**
 * Store a newly created product prefix in storage.
 * Okta scopes for S2S authorization: inventory
 */
export const productPrefix = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/product-prefixes" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete an existing product prefix from storage.
 * Okta scopes for S2S authorization: inventory
 */
export const deleteProductPrefix = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/inventory/product-prefixes/{id}" }, options));
};
/**
 * Show a single product prefix from storage.
 * Okta scopes for S2S authorization: inventory
 */
export const getProductPrefix = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/product-prefixes/{id}" }, options));
};
/**
 * Update an existing product prefix in storage.
 * Okta scopes for S2S authorization: inventory
 */
export const updateProductPrefix = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/inventory/product-prefixes/{id}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Show the Configuration Schemas
 * Okta scopes for S2S authorization: tenant-configuration.read
 */
export const showConfigurationSchemas = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/tenants/configurations/schemas" }, options));
};
/**
 * Bulk update or create the Configuration Items
 * Okta scopes for S2S authorization: tenant-configuration.write
 */
export const bulkUpsertConfigurationItemsController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/tenants/configurations/{id}/items/bulk" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete the Configuration Item
 * Okta scopes for S2S authorization: tenant-configuration.critical
 */
export const deleteConfigurationItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/tenants/configurations/{id}/items/{type}" }, options));
};
/**
 * Show the Configuration Item
 * Okta scopes for S2S authorization: tenant-configuration.read
 */
export const showConfigurationItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/tenants/configurations/{id}/items/{type}" }, options));
};
/**
 * Update the Configuration Item
 * Okta scopes for S2S authorization: tenant-configuration.write
 */
export const updateConfigurationItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/tenants/configurations/{id}/items/{type}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Create the Configuration Item
 * Okta scopes for S2S authorization: tenant-configuration.write
 */
export const createConfigurationItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/tenants/configurations/{id}/items" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get all Configurations
 * Okta scopes for S2S authorization: tenant-configuration.read
 */
export const indexConfigurations = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/tenants/configurations" }, options));
};
/**
 * Create the Configuration
 * Okta scopes for S2S authorization: tenant-configuration.write
 */
export const createConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/tenants/configurations" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete the Configuration
 * Okta scopes for S2S authorization: tenant-configuration.critical
 */
export const deleteConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/tenants/configurations/{id}" }, options));
};
/**
 * Show the Configuration
 * Okta scopes for S2S authorization: tenant-configuration.read
 */
export const showConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/tenants/configurations/{id}" }, options));
};
/**
 * Update the Configuration
 * Okta scopes for S2S authorization: tenant-configuration.write
 */
export const updateConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/tenants/configurations/{id}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get all tenants versions
 * Get all tenants versions
 */
export const getTenantsVersions = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/tenants-versions" }, options));
};
/**
 * Get all Tenants
 * Okta scopes for S2S authorization: tenant.read
 */
export const getTenants = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/tenants" }, options));
};
/**
 * Create the Tenant
 * Okta scopes for S2S authorization: tenant.write
 */
export const createTenant = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/tenants" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete the Tenant
 * Only for tenants with a flag: is_production: false
 * Okta scopes for S2S authorization: tenant.critical
 */
export const deleteTenant = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/tenants/{code}" }, options));
};
/**
 * Get the Tenant
 * Okta scopes for S2S authorization: tenant.read
 */
export const getTenant = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/tenants/{code}" }, options));
};
/**
 * Update the Tenant
 * Okta scopes for S2S authorization: tenant.write
 */
export const updateTenant = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/tenants/{code}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Update the Tenant contact person
 * Okta scopes for S2S authorization: tenant.write
 */
export const updateTenantContactPerson = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/tenants/{code}/contact-person" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Export the encrypted data of the tenant with configuration and items
 * Okta scopes for S2S authorization: tenant.export
 */
export const exportTenant = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/tenants/{code}/export" }, options));
};
/**
 * Import the tenant with configuration and items from encrypted data
 * Okta scopes for S2S authorization: tenant.import
 */
export const importTenant = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/tenants/import" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Migrate the Tenant
 * Okta scopes for S2S authorization: tenant.write
 */
export const migrateTenant = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign({ url: "/api/tenants/{code}/migrate" }, options));
};
/**
 * Lists all the error codes of every existing domain.
 * Okta scopes for S2S authorization: platform.error-codes
 */
export const indexErrorCodes = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/platform/error-codes" }, options));
};
/**
 * List all the error codes for a given domain.
 * Okta scopes for S2S authorization: platform.error-codes
 */
export const showErrorCodes = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/platform/error-codes/{domain}" }, options));
};
/**
 * Get the Platform(Tenant) Version
 * Get the Platform(Tenant) Version
 */
export const getPlatformVersion = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/platform/version" }, options));
};
/**
 * Validate test scenario
 * Okta scopes for S2S authorization: platform
 */
export const validateTestScenario = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ bodySerializer: null, url: "/api/platform/integration-tests/validate" }, options), { headers: Object.assign({ "Content-Type": "text/plain" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Public List of Platform Configurations
 * Public List of Platform Configurations for given codes
 */
export const publicIndexPlatformConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/platform/configuration/public" }, options));
};
/**
 * List the Platform Configuration
 * Okta scopes for S2S authorization: platform.configuration
 */
export const indexPlatformConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/platform/configuration" }, options));
};
/**
 * Create the Platform Configuration
 * Okta scopes for S2S authorization: platform.configuration
 */
export const createPlatformConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/platform/configuration" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete the Platform Configuration
 * Okta scopes for S2S authorization: platform.configuration
 */
export const deletePlatformConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/platform/configuration/{code}" }, options));
};
/**
 * Show the Platform Configuration
 * Okta scopes for S2S authorization: platform.configuration
 */
export const showPlatformConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/platform/configuration/{code}" }, options));
};
/**
 * Update the Platform Configuration
 * Okta scopes for S2S authorization: platform.configuration
 */
export const updatePlatformConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/platform/configuration/{code}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Index the Proxy Tenants
 * Okta scopes for S2S authorization: platform.proxy
 */
export const indexProxyTenants = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/platform/proxy/tenants" }, options));
};
/**
 * Get the Proxy Tenants for service
 * Okta scopes for S2S authorization: platform.proxy
 */
export const getProxyTenantsForService = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/platform/proxy/tenants/{service}" }, options));
};
/**
 * Create the Proxy Tenant for service
 * Okta scopes for S2S authorization: platform.proxy
 */
export const createProxyTenantsForServiceController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/platform/proxy/tenants/{service}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete the Proxy Tenant for service
 * Okta scopes for S2S authorization: platform.proxy
 */
export const deleteProxyTenantsForServiceController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/platform/proxy/tenants/{service}/{tenant}" }, options));
};
/**
 * Index the Proxy Configurations
 * Okta scopes for S2S authorization: platform.proxy
 */
export const indexProxyConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/platform/proxy/configuration" }, options));
};
/**
 * Enable/Disable the Proxy
 * Okta scopes for S2S authorization: platform.proxy
 */
export const enableProxyConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/platform/proxy/configuration" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Enable/Disable the Proxy for the service
 * Okta scopes for S2S authorization: platform.proxy
 */
export const enableProxyForService = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/platform/proxy/configuration/service/{service}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Update or Create Non Tenant Version
 * Okta scopes for S2S authorization: platform.proxy-critical
 */
export const updateOrCreateNonTenantVersion = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/platform/proxy/master/version" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get Proxy Configuration - advanced option
 * Okta scopes for S2S authorization: platform.proxy-critical
 */
export const getProxyConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/platform/proxy/critical/{type}" }, options));
};
/**
 * Force push the proxy configuration to Cloudflare KV - advanced option
 * Okta scopes for S2S authorization: platform.proxy-critical
 */
export const forcePushProxyConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign({ url: "/api/platform/proxy/critical/force/{type}" }, options));
};
/**
 * Update or Create the Proxy Configuration - advanced option
 * Okta scopes for S2S authorization: platform.proxy-critical
 */
export const updateOrCreateProxyConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/platform/proxy/critical/configuration" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Update or Create the Proxy Redirections - advanced option
 * Okta scopes for S2S authorization: platform.proxy-critical
 */
export const updateOrCreateProxyRedirections = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/platform/proxy/critical/redirections" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Update or Create the Proxy Services - advanced option
 * Okta scopes for S2S authorization: platform.proxy-critical
 */
export const updateOrCreateProxyServices = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/platform/proxy/critical/services" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Update or Create the Proxy Tenants - advanced option
 * Okta scopes for S2S authorization: platform.proxy-critical
 */
export const updateOrCreateProxyTenants = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/platform/proxy/critical/tenants" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Generate the Service To Service token (S2S).
 * Generate the Service To Service token (S2S).
 */
export const generateS2sToken = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/platform/oauth2/authorize" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Validate email address
 * Okta scopes for S2S authorization: platform
 */
export const emailValidation = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/platform/email-validation" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Okta oAuth2 redirect
 * Redirect to Okta oAuth2 to get an access token
 */
export const oktaAuthRedirect = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/platform/auth/okta/redirect" }, options));
};
/**
 * Okta oAuth2 callback
 * Callback from Okta oAuth2 to get an access token
 */
export const oktaAuthCallback = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/platform/auth/okta/callback" }, options));
};
/**
 * Okta oAuth2 callback
 * Callback from Okta oAuth2 to get an access token
 */
export const trackingToolsOktaAuthCallback = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/platform/auth/okta/tools-callback" }, options));
};
/**
 * Decrypt the Data
 * Okta scopes for S2S authorization: cryptography.decrypt
 */
export const decryptData = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/cryptography/decrypt" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Encrypt the Data
 * Okta scopes for S2S authorization: cryptography.encrypt
 */
export const encryptData = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/cryptography/encrypt" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete an existing code route from storage.
 * Okta scopes for S2S authorization: code_route
 */
export const deleteCodeRoute = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/code-routes/{code}" }, options));
};
/**
 * Get a single code route from storage
 * Okta scopes for S2S authorization: code_route
 */
export const getCodeRoute = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/code-routes/{code}" }, options));
};
/**
 * Update an existing code route in storage.
 * Okta scopes for S2S authorization: code_route
 */
export const updateCodeRoute = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/code-routes/{code}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get list of all codes from storage
 * Okta scopes for S2S authorization: code_route
 */
export const getCodeRoutes = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/code-routes" }, options));
};
/**
 * Store a newly created code route in storage.
 * Okta scopes for S2S authorization: code_route
 */
export const addCodeRoute = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/code-routes" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Find an Action Verification Item
 * Find an Action Verification Item
 */
export const findActionVerificationItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/action-verifications/items/{uuid}" }, options));
};
/**
 * Create an Action Verification Item
 * Create an Action Verification Item
 */
export const createActionVerification = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/action-verifications/items" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Verify an Action Verification Item
 * Verify an Action Verification Item
 */
export const verifyActionVerification = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/action-verifications/items/{uuid}/verify" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Store a newly created / Update existing marketing communication in storage
 * Okta scopes for S2S authorization: marketing_communication.create_or_update
 */
export const createOrUpdateMarketingCommunication = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/messaging/marketing-communications" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete existing marketing communication from storage
 * Okta scopes for S2S authorization: marketing_communication.delete
 */
export const deleteMarketingCommunication = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/messaging/marketing-communications/{subscriberUuid}" }, options));
};
/**
 * Get list of all matching marketing communications from storage
 * Okta scopes for S2S authorization: marketing_communication.find
 */
export const getMarketingCommunications = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/messaging/marketing-communications/{subscriberUuid}" }, options));
};
/**
 * Update email of existing marketing communications in storage.
 * Okta scopes for S2S authorization: marketing_communication.update_email
 */
export const updateEmailOfMarketingCommunications = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/messaging/marketing-communications/{oldEmail}/email" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Update preferred language of existing marketing communications in storage.
 * Okta scopes for S2S authorization: marketing_communication.update_language
 */
export const updatePreferredLanguageOfMarketingCommunications = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/messaging/marketing-communications/{identifier}/language" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Create a new message event
 * Create a new message event
 */
export const messagingEventCreateMessage = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/messaging/events" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Create a new message from submitted form data with consents, recaptcha etc
 * Create a new message from submitted form data with consents, recaptcha etc
 */
export const messagingFormCreateMessage = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/messaging/forms" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get list of existing messaging templates
 * Okta scopes for S2S authorization: messaging, messaging.templates.list_templates_action
 */
export const messagingTemplatesList = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/messaging/templates" }, options));
};
/**
 * Create a new Messaging template
 * Okta scopes for S2S authorization: messaging, messaging.templates.create_template_action
 */
export const messagingTemplateCreate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/messaging/templates" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Remove existing Messaging template
 * Okta scopes for S2S authorization: messaging, messaging.templates.delete_template_action
 */
export const messagingTemplateDelete = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/messaging/templates/{template}" }, options));
};
/**
 * Get detail of chosen messaging template
 * Okta scopes for S2S authorization: messaging, messaging.templates.get_template_action
 */
export const messagingTemplateDetail = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/messaging/templates/{template}" }, options));
};
/**
 * Update existing template
 * Okta scopes for S2S authorization: messaging, messaging.templates.update_template_action
 */
export const messagingTemplatesUpdate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/messaging/templates/{template}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Update consumer consents
 * Update consents for authenticated consumer
 *
 * Okta scopes for S2S authorization: consents
 */
export const updateConsents = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/consents/users/{uuid}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Webhook to accept changes coming from OneTrust.
 * Webhook to accept changes coming from OneTrust.
 */
export const updateOneTrustPreferenceWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/webhooks/one-trust/update-consent" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Endpoint to synchronize OneTrust purposes with local data.
 * Endpoint to synchronize OneTrust purposes with local data.
 */
export const syncOneTrustPurposes = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/webhooks/one-trust/sync-purposes" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get the list of available webhook transformers
 * Okta scopes for S2S authorization: webhooks
 */
export const getWebhookTransformers = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/webhooks/transformers" }, options));
};
/**
 * Get the list of webhooks for tenant.
 * Okta scopes for S2S authorization: webhooks
 */
export const getWebhooks = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/webhooks" }, options));
};
/**
 * Store new tenant webhook
 * Okta scopes for S2S authorization: webhooks
 */
export const createWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/webhooks" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Remove specific webhook
 * Okta scopes for S2S authorization: webhooks
 */
export const deleteWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/webhooks/{webhook_id}" }, options));
};
/**
 * Show specific webhook
 * Okta scopes for S2S authorization: webhooks
 */
export const getWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/webhooks/{webhook_id}" }, options));
};
/**
 * Update specific webhook
 * Okta scopes for S2S authorization: webhooks
 */
export const updateWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/webhooks/{webhook_id}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Make search request
 * Make search request
 */
export const searchSearchableItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/search" }, options));
};
/**
 * Create or update searchable item
 * Okta scopes for S2S authorization: search.indexing
 */
export const storeSearchableItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/search/index" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Remove all searchable items from the index
 * Okta scopes for S2S authorization: search.purge-critical
 */
export const purgeSearchable = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/search/index/purge" }, options));
};
/**
 * Delete searchable item
 * Okta scopes for S2S authorization: search.indexing
 */
export const deleteSearchable = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/search/index/{item_id}" }, options));
};
/**
 * Sync indexes
 * Okta scopes for S2S authorization: search.sync
 * This endpoint can be queried in 3 ways
 * - with Okta Auth
 * - with the X-DES-STATIC-TOKEN header (configured as DES_EVO_STATIC_TOKEN, also if DES_EVO_ALLOWED_IPS is set, the request must originate from one of the allowed IPs
 */
export const syncIndexes = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/search/index/sync" }, options));
};
/**
 * Validate Inventory Item Code using specified Code.
 * The inventory item must be a real existing identified at the time of request.<br>
 *
 * Okta scopes for S2S authorization: inventory
 */
export const validateInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/items/{inventory_item_code}/validate" }, options));
};
/**
 * The inventory Item list for a specific user.
 * The inventory item is registered by the User at the time of request.<br>
 *
 * Okta scopes for S2S authorization: inventory
 */
export const indexInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/items" }, options));
};
/**
 * Restores the inventory item to a state that allows registration.
 * Removes all registrations, warranties, and other data associated with the inventory item.
 *
 * The inventory item must be a real existing identified.<br>
 *
 * Okta scopes for S2S authorization: inventory, inventory.items-critical
 */
export const restoreInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/inventory/items/{inventory_item_code}" }, options));
};
/**
 * Get the specified Inventory Item by Code.
 * The inventory item must be a real existing identified.<br>
 *
 * Okta scopes for S2S authorization: inventory
 */
export const showInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/items/{inventory_item_code}" }, options));
};
/**
 * Sets Inventory Item registrability.
 * Affects any feature related to device registration.<br>
 *
 * Okta scopes for S2S authorization: inventory
 */
export const setRegistrabilityInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/items/{inventory_item_code}/set-registrability" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Register Inventory Item using specified Code.
 * The inventory item must be a real existing identified and not be registered to any other User at the time of request.<br>
 *
 * Okta scopes for S2S authorization: inventory
 */
export const registerInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/items/{inventory_item_code}/register" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Unregister Inventory Item using specified Code.
 * The inventory item must be registered to the User at the time of request.<br>
 * The inventory item must be unregisterable.<br>
 *
 * Okta scopes for S2S authorization: inventory
 */
export const unregisterInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/items/{inventory_item_code}/unregister" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Attach the consumer to the Inventory Item.
 * To complete the inventory item registration flow.<br>
 * The inventory item must be registered by the External DES ID or Personal Identifier.<br>
 *
 * Okta scopes for S2S authorization: inventory
 */
export const attachConsumerToInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/items/{inventory_item_code}/attach" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Returns information about ability to attach owner to the inventory item.
 * The inventory item must exist.<br>
 *
 * Okta scopes for S2S authorization: inventory
 */
export const isAttachableToConsumer = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/items/{inventory_item_code}/is-attachable" }, options));
};
/**
 * Show existing Warranty for specific Inventory Item Code.
 * Okta scopes for S2S authorization: inventory, inventory.show
 */
export const getWarranty = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/items/{inventory_item_code}/warranty" }, options));
};
/**
 * Update existing Warranty for specific Inventory Item Code.
 * Okta scopes for S2S authorization: inventory, inventory.warranties.update
 */
export const updateWarranty = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/inventory/items/{inventory_item_code}/warranty" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Cancel existing Warranty for specific Inventory Item Code.
 * Okta scopes for S2S authorization: inventory, inventory.cancel
 */
export const canceledWarranty = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/items/{inventory_item_code}/warranty/cancel" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Inventory Item list for logged user.
 * The inventory item is registered by the logged User at the time of request.<br>
 *
 * Okta scopes for S2S authorization: inventory, inventory.items.index
 */
export const userIndexInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users/inventory/items" }, options));
};
/**
 * Register Inventory Item using specified Code for logged user.
 * The inventory item must be a real existing identified and not be registered to any other User at the time of request.<br>
 *
 * Okta scopes for S2S authorization: inventory, inventory.items.register
 */
export const userRegisterInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/users/inventory/items/{inventory_item_code}/register" }, options));
};
/**
 * Inventory Item Unregistration using specified Code for logged user.
 * The inventory item must be registered to the logged User at the time of request.<br>
 * The inventory item must be unregisterable.<br>
 *
 * Okta scopes for S2S authorization: inventory
 */
export const userUnregisterInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/users/inventory/items/{inventory_item_code}/unregister" }, options));
};
/**
 * Returns information about ability to attach owner to the inventory item.
 * The inventory item must exist.<br>
 *
 * Okta scopes for S2S authorization: inventory
 */
export const userIsAttachableInventoryItem = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users/inventory/items/{inventory_item_code}/is-attachable" }, options));
};
/**
 * List of Inventory Items for reporting purposes.
 * Okta scopes for S2S authorization: inventory, inventory-reporting.read
 */
export const inventoryItemsReport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/reporting/items" }, options));
};
/**
 * Exports the list of Inventory Items for reporting purposes.
 * Okta scopes for S2S authorization: inventory, inventory-reporting.read
 */
export const inventoryItemsReportExport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/reporting/items/export" }, options));
};
/**
 * Inventory Import statistics for reporting purposes.
 * Okta scopes for S2S authorization: inventory, inventory-reporting.read
 */
export const inventoryImportReport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/reporting/imports" }, options));
};
/**
 * Inventory import errors for reporting purposes.
 * Okta scopes for S2S authorization: inventory, inventory-reporting.read
 */
export const inventoryImportErrors = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/reporting/imports/{id}/errors" }, options));
};
/**
 * List of prefixes with products information for reporting purposes.
 * Okta scopes for S2S authorization: inventory, inventory-reporting.read
 */
export const prefixesReport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/reporting/prefixes" }, options));
};
/**
 * Triggers the import of the inventory items
 * If the filename is provided, the import will be triggered only for that file as a background job<br>
 * Otherwise, the import will be triggered for all the files in the source directory<br>
 * Okta scopes for S2S authorization: inventory, inventory-import.write
 */
export const inventoryItemsImport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/import/items" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Triggers the import of the device inventory or temporary consumers import
 * The import will be triggered only for that file as a background job<br>
 * Okta scopes for S2S authorization: inventory, inventory-import.write
 */
export const diSv1StorageImport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/import/device-inventory/storage" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Import device inventory data from a payload
 * The import will be triggered only for that payload as a background job<br>
 * Okta scopes for S2S authorization: inventory, inventory-import.write
 */
export const diSv1PayloadImport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/import/device-inventory/payload" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Triggers the import of the pack codes
 * Okta scopes for S2S authorization: inventory, inventory-import.write
 */
export const packCodesImport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/import/pack-codes" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get list of all spex clusters
 * Okta scopes for S2S authorization: inventory
 */
export const getSpexClusters = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/spex-clusters" }, options));
};
/**
 * Store a new spex cluster
 * Okta scopes for S2S authorization: inventory
 */
export const spexCluster = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/inventory/spex-clusters" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete an existing spex cluster
 * Okta scopes for S2S authorization: inventory
 */
export const destroySpexCluster = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/inventory/spex-clusters/{name}" }, options));
};
/**
 * Show a single spex cluster
 * Okta scopes for S2S authorization: inventory
 */
export const showSpexCluster = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/inventory/spex-clusters/{name}" }, options));
};
/**
 * Update an existing spex cluster country codes.
 * Okta scopes for S2S authorization: inventory
 */
export const updateSpexCluster = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/inventory/spex-clusters/{name}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Persist reviews from Trustpilot
 * When new review is being published on Trustpilot by user, Trustpilot notifies RPS,
 * RPS fetch the new reviews from it and store in DB
 */
export const productReviewEvent = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/products/reviews/event" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Trigger fetching all reviews from Trustpilot, for purpose when Trustpilot credential being updated
 * Okta scopes for S2S authorization: products.reviews
 */
export const allProductReviewEvents = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/products/reviews/sync" }, options));
};
/**
 * Get products list with pagination.
 * Okta scopes for S2S authorization: products.index
 */
export const indexProduct = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/products" }, options));
};
/**
 * Show single product.
 * Okta scopes for S2S authorization: products.show
 */
export const showProduct = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/products/{sku}" }, options));
};
/**
 * Import a product base one Magento.
 * Okta scopes for S2S authorization: products.import
 */
export const importProduct = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/products/import" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete a product base one Magento.
 * Okta scopes for S2S authorization: products.import
 */
export const importDeleteProduct = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/products/import/{sku}" }, options));
};
/**
 * Init authorisation
 * Init authorisation
 */
export const initAuthorisation = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/payments/authorisations/init" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Show available credit cards
 * Show available credit cards
 */
export const getCreditCards = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/payments/cards" }, options));
};
/**
 * Get credit card by uuid
 * Get credit card by uuid
 */
export const getCreditCard = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/payments/cards/{uuid}" }, options));
};
/**
 * Generate a payment token and store affected order in the database
 * Generate a payment token and store affected order in the database
 */
export const createPayment = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/payments/generate-token" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Show available payment methods
 * Show available payment methods
 */
export const getPaymentMethods = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/payments/methods" }, options));
};
/**
 * Store new payment method
 * Okta scopes for S2S authorization: payments.methods
 */
export const storePaymentMethod = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/payments/methods" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Return JS client for given payment method
 * Return JS client for given payment method
 */
export const getPaymentMethodClient = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/payments/methods/{code}/client" }, options));
};
/**
 * Show payment by UUID
 * Show payment by UUID
 */
export const getPayment = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/payments/{uuid}" }, options));
};
/**
 * Update payment by UUID
 * Okta scopes for S2S authorization: payments.update
 */
export const updatePayment = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/payments/{uuid}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Show token by order id
 * Show token by order id
 */
export const getToken = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/payments/tokens/{order_id}" }, options));
};
/**
 * Init payment session
 * Init payment session
 */
export const initPaymentSession = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/payments/sessions/init" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Show refund by UUID
 * Okta scopes for S2S authorization: payments.update
 */
export const getRefund = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/payments/refunds/{uuid}" }, options));
};
/**
 * Update refund by UUID
 * Okta scopes for S2S authorization: payments.update
 */
export const updateRefund = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/payments/refunds/{uuid}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Show transaction by external id
 * Okta scopes for S2S authorization: payments.update
 */
export const getTransaction = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/payments/transactions/{external_id}" }, options));
};
/**
 * Get payment external data
 * Okta scopes for S2S authorization: payments.update
 */
export const getPaymentExternalData = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/payments/data/{uuid}" }, options));
};
/**
 * Update payment external data
 * Okta scopes for S2S authorization: payments.update
 */
export const updatePaymentExternalData = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/payments/data/{uuid}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Store authorisation
 * Okta scopes for S2S authorization: payments.update
 */
export const storeAuthorisation = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/payments/authorisations" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Create new refund
 * Okta scopes for S2S authorization: payments
 */
export const createRefund = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/payments/refunds" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete payment method by code
 * Okta scopes for S2S authorization: payments.methods
 */
export const deletePaymentMethod = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/payments/methods/{code}" }, options));
};
/**
 * Show payment method by code
 * Okta scopes for S2S authorization: payments.methods
 */
export const getPaymentMethod = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/payments/methods/{code}" }, options));
};
/**
 * Update payment method by code
 * Okta scopes for S2S authorization: payments.methods
 */
export const updatePaymentMethod = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/payments/methods/{code}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get all Imports
 * Okta scopes for S2S authorization: import.read
 */
export const getImports = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/imports" }, options));
};
/**
 * Create the Import
 * Okta scopes for S2S authorization: import.write
 */
export const createImport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/imports" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Cleanup the Import
 * Okta scopes for S2S authorization: import.write
 */
export const cleanupImport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/imports/{importId}" }, options));
};
/**
 * Get the Import
 * Okta scopes for S2S authorization: import.read
 */
export const getImport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/imports/{importId}" }, options));
};
/**
 * Start the Import
 * Okta scopes for S2S authorization: import.write
 */
export const startImport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign({ url: "/api/imports/{importId}" }, options));
};
/**
 * Get all Imports
 * Okta scopes for S2S authorization: import.read
 */
export const getImportsDomain = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/imports/{importId}/domains" }, options));
};
/**
 * Get the Import
 * Okta scopes for S2S authorization: import.read
 */
export const getImportDomain = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/imports/{importId}/domains/{importDomainId}" }, options));
};
/**
 * Resume the Domain Import
 * Okta scopes for S2S authorization: import.write
 */
export const resumeImportDomain = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign({ url: "/api/imports/{importId}/domains/{importDomainId}" }, options));
};
/**
 * Get all Imports
 * Okta scopes for S2S authorization: import.read
 */
export const getImportsDomainItems = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/imports/{importId}/domains/{importDomainId}/items" }, options));
};
/**
 * Get the list of adapters.
 * Get the list of adapters.
 */
export const getAdapters = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/adapters" }, options));
};
/**
 * Store new adapter
 * Store new adapter
 */
export const createAdapter = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/adapters" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Remove specific adapter
 * Remove specific adapter
 */
export const deleteAdapter = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/adapters/{adapter_code}" }, options));
};
/**
 * Show specific adapter
 * Show specific adapter
 */
export const getAdapter = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/adapters/{adapter_code}" }, options));
};
/**
 * Update specific adapter
 * Update specific adapter
 */
export const updateAdapter = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/adapters/{adapter_code}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Connect adapter to tenant
 * Okta scopes for S2S authorization: adapters
 */
export const connectAdapter = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/adapters/connect" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Disconnect adapter
 * Okta scopes for S2S authorization: adapters
 */
export const disconnectAdapter = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/adapters/disconnect" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Returns all available verification methods
 * Returns all available verification methods
 */
export const getAvailableVerificationMethodsController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/age-verification/methods" }, options));
};
/**
 * Returns if tenant has hidden verification
 * Returns if tenant has hidden verification
 */
export const checkIfHasHiddenVerificationController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/age-verification/methods/has-hidden-verification" }, options));
};
/**
 * Performs age verification for synchronous method and verify already initialized verification for asynchronous method
 * Performs age verification for synchronous method and verify already initialized verification for asynchronous method
 */
export const performAgeVerificationController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/age-verification/verify/init" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Initializes asynchronous age verification
 * Initializes asynchronous age verification
 */
export const initializeAsynchronousAgeVerificationController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/age-verification/verify/init-async" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Gets age verification result
 * Gets age verification result
 */
export const getAgeVerificationResultController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/age-verification/verify/verification-result/{uuid}/{token}" }, options));
};
/**
 * Gets date of performing age verification for given token
 * Gets date of performing age verification for given token
 */
export const getAgeVerificationDateController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/age-verification/verify/{token}/date" }, options));
};
/**
 * Updates consumer uuid in age verification item hash
 * Updates consumer uuid in age verification item hash
 */
export const updateConsumerUuidController = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/age-verification/webhooks/update-consumer-uuid" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Gets users public domain configuration
 * Gets users public domain configuration
 */
export const getUsersPublicDomainConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users/configuration" }, options));
};
/**
 * Logouts user and deletes given user token
 * Logouts user and deletes given user token
 */
export const logout = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/users/authentication/sessions" }, options));
};
/**
 * Authenticate a User
 * Authenticate a user based on their credentials and related strategy. Returning an auth token upon success.
 *
 * Okta scopes for S2S authorization: users-authentication
 */
export const authenticate = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/authentication/sessions" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Validates given user token
 * Validates given user token
 */
export const validateSession = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/authentication/sessions/validate" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Issue and send forgot password token for a user
 * It creates and sends forgot password token for existing user (by email)
 * Okta scopes for S2S authorization: users-authentication
 */
export const forgotPassword = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/authentication/password/forget" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Change password for a user
 * It sets new password for authenticated user
 * Change password for a user
 * It sets new password for authenticated user
 */
export const changePassword = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/authentication/password/change" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Set new password for a user
 * It sets new password for a user identified by provided forgot password token
 * Okta scopes for S2S authorization: users-authentication
 */
export const setPassword = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/authentication/password/change/{token}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Verify referral code
 * Okta scopes for S2S authorization: users.referrals
 */
export const verifyReferralCode = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users/referrals/{code}/verify" }, options));
};
/**
 * Streams a wallet pass for download
 * Streams a wallet pass for download
 */
export const streamedWalletPass = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users/{uuid}/wallets/{walletProvider}/stream" }, options));
};
/**
 * Register a consumer
 * Okta scopes for S2S authorization: users-registration
 */
export const register = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/register" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Synchronize consumer addresses
 * Synchronize all addresses for consumer
 *
 * Okta scopes for S2S authorization: users.addresses-sync
 */
export const synchronizeAddresses = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/users/{identifier}/addresses/sync" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Store consumer address
 * Store new address for authenticated consumer
 */
export const storeAddress = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/{uuid}/addresses" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete consumer address
 * Delete existing address for authenticated consumer
 */
export const deleteAddress = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/users/{uuid}/addresses/{addressId}" }, options));
};
/**
 * Update consumer address
 * Update existing address for authenticated consumer
 */
export const updateAddress = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/users/{uuid}/addresses/{addressId}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Set default address
 * Set existing address as default shipping or billing for authenticated consumer
 */
export const setDefaultAddress = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign({ url: "/api/users/{uuid}/addresses/{addressType}/{addressId}" }, options));
};
/**
 * Verify consumer age.
 * Verify consumer age.
 */
export const verifyAge = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/{uuid}/av" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Request promo code for authenticated consumer
 * Request promo code for authenticated consumer
 */
export const requestPromoCode = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/users/{uuid}/coupons" }, options));
};
/**
 * Check whether the user has any complaints with `special_complaint` flag stored in the CDP
 * Check whether the user has any complaints with `special_complaint` flag stored in the CDP
 */
export const getComplaints = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users/{uuid}/complaints" }, options));
};
/**
 * Update consumer custom attributes
 * Update custom attributes for authenticated consumer
 */
export const updateCustomAttributes = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/users/{uuid}/custom-attributes" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete consumer custom attribute
 * Delete custom attribute for authenticated consumer
 */
export const deleteCustomAttribute = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/users/{uuid}/custom-attributes/{customAttribute}" }, options));
};
/**
 * Update consumer custom attribute
 * Update custom attribute for authenticated consumer
 */
export const updateCustomAttribute = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/users/{uuid}/custom-attributes/{customAttribute}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get user profile
 * Get user profile
 */
export const getProfile = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users/{uuid}/profile" }, options));
};
/**
 * Update user profile
 * Update user profile
 */
export const updateProfile = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/{uuid}/profile" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Create the update email request
 * Create the update email request
 */
export const updateEmailRequest = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/{uuid}/profile/email/request-update" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Change consumer phone
 * Change consumer phone
 */
export const changePhone = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/users/{uuid}/profile/phone" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Assign consumer referrer
 * Assign consumer referrer
 */
export const assignReferrer = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/users/{uuid}/profile/referrer-code" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Generates a wallet pass
 * Okta scopes for S2S authorization: users-wallets
 */
export const generateWalletPass = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/{uuid}/profile/wallet" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Anonymize a single consumer.
 * Anonymize a single consumer.
 */
export const anonymizeConsumer = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/users/{uuid}/cancel" }, options));
};
/**
 * Verify phone or email.
 * Verify phone or email.
 */
export const verifyPhoneOrEmail = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users/verify/{phone_or_email}" }, options));
};
/**
 * Change consumer email
 * Change consumer email
 */
export const changeConsumerEmail = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/users/profile/email" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Request the user's data.
 * Request the user's data.
 */
export const dataSubjectAccessRequest = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/privacy" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get the purposes for the requested context including if the user confirmed
 * or rejected them.
 * Okta scopes for S2S authorization: users.consents
 */
export const getUsersConsents = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users/{uuid}/consents" }, options));
};
/**
 * Update consumer consents
 * Update consents for authenticated consumer
 *
 * Okta scopes for S2S authorization: users.consents
 */
export const deprecatedUpdateConsents = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/users/{uuid}/consents" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Process a list of profiles that come from CDP.
 * Process a list of profiles that come from CDP.
 */
export const processAnonymizedCdpProfiles = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/cancel" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Register offline action and set has_first_referrer_purchase flag to user if applicable
 * Okta scopes for S2S authorization: users.referrals
 */
export const referralsRegisterOfflineAction = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/referrals/register-offline-action" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Endpoint to get available purposes to be viewed in the frontend.
 * Endpoint to get available purposes to be viewed in the frontend.
 */
export const getAvailableConsents = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/consents" }, options));
};
/**
 * Deactivate a single consumer.
 * Okta scopes for S2S authorization: users.deactivate
 */
export const deactivateConsumer = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/{uuid}/deactivate" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * List of consumers for reporting purposes.
 * Okta scopes for S2S authorization: users-reporting.read
 */
export const consumersReport = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users" }, options));
};
/**
 * Anonymize a single consumer manually.
 * Okta scopes for S2S authorization: users.anonymize
 */
export const anonymizeConsumerManually = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/users/{uuid}/anonymize" }, options));
};
/**
 * Unlocks consumer's login if it is locked out due to reaching failed login attempts
 * Okta scopes for S2S authorization: users.unlock
 */
export const unlockConsumerLogin = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/users/{uuid}/unlock" }, options));
};
/**
 * Get user profile. Do not use this endpoint. This is only to be used by
 * the proxy.
 * Okta scopes for S2S authorization: unreachable.because.legacy
 */
export const getProfileForService = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/s2s/users/{uuid}" }, options));
};
/**
 * Activate a single consumer.
 * Okta scopes for S2S authorization: users.activate
 */
export const activateConsumer = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/users/{uuid}/activate" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Process a kakao unlink request.
 * Process a kakao unlink request.
 */
export const processKakaoUnlinkRequest = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/webhooks/users/authentication/kakao/callback" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Generate new coupons in a bulk way and create a new batch
 * Generate new coupons in a bulk way and create a new batch
 */
export const bulkGenerateCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/coupons/bulk/generate" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Retrieve generated coupons for existing batch (one-time operation per batch)
 * Retrieve generated coupons for existing batch (one-time operation per batch)
 */
export const bulkGetCouponBatch = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/coupons/bulk/generate/{batch_id}" }, options));
};
/**
 * Retrieve batch status of previously generated coupons
 * Retrieve batch status of previously generated coupons
 */
export const bulkGetCouponBatchStatus = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/coupons/bulk/generate/{batch_id}/status" }, options));
};
/**
 * Get a list of available external providers.
 * Get a list of available external providers.
 */
export const getExternalProviders = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/coupons/external/providers/{country}" }, options));
};
/**
 * Generate a single coupon
 * Okta scopes for S2S authorization: coupons
 */
export const generateSingleCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/coupons/generate" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Retrieve all users assigned to a coupon
 * Okta scopes for S2S authorization: coupons
 */
export const getCouponUsers = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/coupons/{code}/users" }, options));
};
/**
 * Global Webhook to generate a new coupon
 * Global Webhook to generate a new coupon
 */
export const couponGenerationWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/coupons/global-webhooks/generate" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Request an external coupon.
 * Request an external coupon.
 */
export const requestExternalCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/coupons/external/providers/{provider}/request" }, options));
};
/**
 * Request an external coupon.
 * Okta scopes for S2S authorization: coupons.external.request
 */
export const serviceRequestExternalCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/services/coupons/external/providers/{provider}/request" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get the Activity Logs
 * Okta scopes for S2S authorization: monitoring.activity_log
 */
export const getActivityLogs = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/monitoring/activity-log" }, options));
};
/**
 * View the health check results.
 * Okta scopes for S2S authorization: monitoring.health-checks.index
 */
export const getHealthCheck = (options) => {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/healthcheck" }, options));
};
/**
 * View the tenant health check results.
 * Okta scopes for S2S authorization: monitoring.health-checks.index
 */
export const getTenantHealthCheck = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/tenant-healthcheck" }, options));
};
/**
 * Export list of orders
 * Okta scopes for S2S authorization: orders.export
 */
export const getOrders = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/orders" }, options));
};
/**
 * Store new order or updated order
 * Okta scopes for S2S authorization: orders.store
 */
export const storeOrder = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/orders" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Fetch consumer invoice
 * Fetch the invoice of a consumer that belongs to the specified order. The returned link is valid for one day (24h).
 *
 * Okta scopes for S2S authorization: orders.export
 */
export const fetchInvoice = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/users/{uuid}/orders/{orderId}/invoice" }, options));
};
/**
 * Create new order in Magento
 * Okta scopes for S2S authorization: orders
 */
export const createOrder = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/orders/create" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Create new order cancellation request
 * Create new order cancellation request
 */
export const storeCancellationRequest = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/orders/request-cancellation" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get single order
 * Okta scopes for S2S authorization: orders.export
 */
export const getOrder = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/orders/{order_id}" }, options));
};
/**
 * Update order shipping information
 * Okta scopes for S2S authorization: orders.update
 */
export const updateShipping = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/orders/{order_id}/shipping-info" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Update order status
 * Okta scopes for S2S authorization: orders.update
 */
export const updateOrderStatus = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/orders/{order_id}/status" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Update order invoice
 * Okta scopes for S2S authorization: orders.update
 */
export const updateOrderInvoice = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/orders/{order_id}/invoice" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Reject order
 * Okta scopes for S2S authorization: orders.update
 */
export const rejectOrder = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/orders/{order_id}/reject" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Hold order
 * Okta scopes for S2S authorization: orders.update
 */
export const holdOrder = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/orders/{order_id}/hold" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Cancel order
 * Okta scopes for S2S authorization: orders.update
 */
export const cancelOrder = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/orders/{order_id}/cancel" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Store new subscription
 * Okta scopes for S2S authorization: subscriptions
 */
export const storeSubscription = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/subscriptions" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Check if consumer is eligible for subscription
 * Okta scopes for S2S authorization: subscriptions
 */
export const isConsumerEligibleForSubscriptions = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/subscriptions/is-eligible/consumer/{consumer_id}" }, options));
};
/**
 * Check if shipping address is eligible for removal
 * Okta scopes for S2S authorization: subscriptions
 */
export const isShippingAddressEligibleForRemoval = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/subscriptions/is-eligible/shipping-address/{address_id}" }, options));
};
/**
 * Update subscription charge
 * Okta scopes for S2S authorization: subscriptions
 */
export const updateSubscriptionCharge = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/subscriptions/{uuid}/charge" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Show subscription events
 * Okta scopes for S2S authorization: subscriptions
 */
export const showSubscriptionEvents = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/subscriptions/{uuid}/events" }, options));
};
/**
 * Update subscription status
 * Okta scopes for S2S authorization: subscriptions
 */
export const updateSubscriptionStatus = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/subscriptions/{uuid}/status" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Update subscription
 * Okta scopes for S2S authorization: subscriptions
 */
export const updateSubscription = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/subscriptions/{uuid}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Cancel subscription
 * Okta scopes for S2S authorization: subscriptions
 */
export const cancelSubscription = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign({ url: "/api/subscriptions/{uuid}/cancel" }, options));
};
/**
 * Pause subscription
 * Okta scopes for S2S authorization: subscriptions
 */
export const pauseSubscription = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign({ url: "/api/subscriptions/{uuid}/pause" }, options));
};
/**
 * Resume subscription
 * Okta scopes for S2S authorization: subscriptions
 */
export const resumeSubscription = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign({ url: "/api/subscriptions/{uuid}/resume" }, options));
};
/**
 * Show user's subscription
 * Show user's subscription
 */
export const showUserSubscription = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/subscriptions/user" }, options));
};
/**
 * Subscription configurations
 * Subscription configurations
 */
export const subscriptionConfigurations = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/subscriptions/configurations" }, options));
};
/**
 * Checks if customer is eligible for trial program
 * Okta scopes for S2S authorization: trials
 */
export const isEligibleForTrial = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/trials/is-eligible/{program}/{consumer}" }, options));
};
/**
 * Get list of actions
 * Okta scopes for S2S authorization: leads
 */
export const getActions = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/leads/actions" }, options));
};
/**
 * Store new action
 * Okta scopes for S2S authorization: leads
 */
export const storeAction = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/leads/actions" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Store new device registration action
 * Okta scopes for S2S authorization: leads
 */
export const storeDeviceRegistrationAction = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/leads/actions/devices/register" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Store new order action
 * Okta scopes for S2S authorization: leads
 */
export const storeOrderAction = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/leads/actions/orders" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get single action
 * Okta scopes for S2S authorization: leads
 */
export const getAction = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/leads/actions/{uuid}" }, options));
};
/**
 * Update single action
 * Okta scopes for S2S authorization: leads
 */
export const updateAction = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/leads/actions/{uuid}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get list of leads
 * Okta scopes for S2S authorization: leads
 */
export const getLeads = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/leads" }, options));
};
/**
 * Store new lead
 * Okta scopes for S2S authorization: leads
 */
export const storeLead = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/leads" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Cancel a lead by provided Lead UUID or email or phone
 * Okta scopes for S2S authorization: leads
 */
export const cancelLead = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/leads/{identifier}" }, options));
};
/**
 * Get single lead
 * Okta scopes for S2S authorization: leads
 */
export const getLead = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/leads/{identifier}" }, options));
};
/**
 * Update single lead
 * Okta scopes for S2S authorization: leads
 */
export const updateLead = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).patch(Object.assign(Object.assign({ url: "/api/leads/{identifier}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Validate a double opt-in consent
 * Validate and record a double opt-in consent identified by the hash provided in the URL
 */
export const validateConsent = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/leads/consents/validate/{hash}" }, options));
};
/**
 * List purchase actions
 * List purchase actions for authenticated consumer (lead)
 */
export const getPurchases = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/leads/{uuid}/actions/purchase" }, options));
};
/**
 * Get purchase action
 * Get purchase action for authenticated consumer (lead) by action uuid
 */
export const getPurchase = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/leads/{uuid}/actions/purchase/{actionUuid}" }, options));
};
/**
 * Deactivates consumer in loyalty
 * Okta scopes for S2S authorization: loyalty-consumers.write
 */
export const deactivateConsumerInLoyalty = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}" }, options));
};
/**
 * Get consumer loyalty profile via s2s
 * Okta scopes for S2S authorization: loyalty-consumers.read
 */
export const getConsumerLoyaltyProfileS2S = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}" }, options));
};
/**
 * Activates consumer in loyalty
 * Okta scopes for S2S authorization: loyalty-consumers.write
 */
export const activateConsumerInLoyalty = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}" }, options));
};
/**
 * Get consumer network points
 * Okta scopes for S2S authorization: loyalty-points.read
 */
export const getConsumerNetworkPoints = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}/points" }, options));
};
/**
 * Trigger adding points to consumer
 * Okta scopes for S2S authorization: loyalty-points.write
 */
export const triggerAddingConsumerPointsByType = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}/points" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Increase consumer points
 * Okta scopes for S2S authorization: loyalty-points.write
 */
export const increaseConsumerPoints = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}/points/increase" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Decrease consumer points
 * Okta scopes for S2S authorization: loyalty-points.write
 */
export const decreaseConsumerPoints = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}/points/decrease" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Trigger events for many consumers
 * Okta scopes for S2S authorization: loyalty-points.write
 */
export const triggerBulkEvents = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/services/consumers/points" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get list of consumer rewards
 * Okta scopes for S2S authorization: loyalty-rewards.read
 */
export const getConsumerRewards = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}/rewards" }, options));
};
/**
 * Get list of consumer eligible rewards
 * Okta scopes for S2S authorization: loyalty-rewards.read
 */
export const getConsumerEligibleRewardsForService = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}/rewards" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Check the reward is eligible for consumer
 * Okta scopes for S2S authorization: loyalty-rewards.read
 */
export const checkRewardEligibilityController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}/reward/{reward_uuid}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Redeem reward
 * Okta scopes for S2S authorization: loyalty-rewards.write
 */
export const redeemReward = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}/reward" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get consumer tier level via s2s
 * Okta scopes for S2S authorization: loyalty-consumers.read
 */
export const getConsumerTierS2S = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/services/consumers/{uuid}/tier" }, options));
};
/**
 * Get list of tiers
 * Okta scopes for S2S authorization: loyalty-tiers.read
 */
export const getTiersService = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/services/tiers" }, options));
};
/**
 * Add coupons to the reward
 * Okta scopes for S2S authorization: loyalty-rewards.write
 */
export const addCouponsToReward = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/loyalty/services/reward/{uuid}/coupons" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get list of tiers
 * Get list of tiers
 */
export const getTiers = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/tiers" }, options));
};
/**
 * Get consumer points history
 * Okta scopes for S2S authorization: loyalty-points.read
 */
export const getConsumerPointsHistory = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/points" }, options));
};
/**
 * Get consumer redeem reward
 * Get consumer redeem reward
 */
export const getConsumerReward = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/reward/{reward_uuid}" }, options));
};
/**
 * Get consumer loyalty profile
 * Get consumer loyalty profile
 */
export const getConsumerLoyaltyProfile = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}" }, options));
};
/**
 * Get consumer tier level
 * Get consumer tier level
 */
export const getConsumerTier = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/tier" }, options));
};
/**
 * Gets loyalty public domain configuration
 * Gets loyalty public domain configuration
 */
export const getLoyaltyPublicDomainConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/configuration" }, options));
};
/**
 * List rewards - campaigns and prizes
 * List rewards - campaigns and prizes
 */
export const indexRewards = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/rewards" }, options));
};
/**
 * Get reward detail.
 * Get reward detail.
 */
export const getReward = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/reward/{uuid}" }, options));
};
/**
 * List earnings - articles or product
 * List earnings - articles or product
 */
export const indexEarnings = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/earnings" }, options));
};
/**
 * Trigger article read
 * Trigger article read
 */
export const articleRead = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/consumers/{uuid}/earnings/article" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Trigger QR code read
 * Trigger QR code read
 */
export const qrCodeRead = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/consumers/{uuid}/earnings/qr-code" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * List consumer earnings - articles, products
 * List consumer earnings - articles, products
 */
export const getEarningsForConsumer = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/earnings" }, options));
};
/**
 * Get QR Code details
 * Get QR Code details
 */
export const getQrCodeDetails = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/earnings/qr-code/{id}" }, options));
};
/**
 * Get list of consumer rewards (campaigns or prizes)
 * Get list of consumer rewards (campaigns or prizes)
 */
export const getConsumerRewardsCampaignsOrPrizes = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/rewards" }, options));
};
/**
 * Get list of consumer eligible rewards
 * Get list of consumer eligible rewards
 */
export const getConsumerEligibleRewards = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/consumers/{uuid}/rewards" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get consumer achievements
 * Get consumer achievements
 */
export const getAchievements = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/achievements" }, options));
};
/**
 * Get available surveys for specific consumer (surveys which are configured, valid and the consumer hasn't started them yet)
 * Get available surveys for specific consumer (surveys which are configured, valid and the consumer hasn't started them yet)
 */
export const getAvailableSurveysForConsumer = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/surveys" }, options));
};
/**
 * Get consumer survey status
 * Get consumer survey status
 */
export const getConsumerSurveyStatus = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/survey/{survey_id}/status" }, options));
};
/**
 * Consumer survey started
 * Consumer survey started
 */
export const consumerSurveyStartedController = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/consumers/{uuid}/survey/{survey_id}/start" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Submit contest
 * Submit contest
 */
export const submitContest = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/consumers/{uuid}/contests" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get contest status
 * Get contest status
 */
export const getContestStatus = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/contests/status" }, options));
};
/**
 * Get consumer order
 * Get consumer order
 */
export const getConsumerOrder = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/orders/{order_id}" }, options));
};
/**
 * Buy prize for consumer
 * Buy prize for consumer
 */
export const buyPrize = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/loyalty/consumers/{uuid}/reward" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get earning rule by event name
 * Okta scopes for S2S authorization: loyalty-earnings.read
 */
export const getEarningRuleByName = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/loyalty/consumers/{uuid}/earning-rule/{event_name}" }, options));
};
/**
 * Handles Open Loyalty incoming webhook event when consumer level changed
 * Handles Open Loyalty incoming webhook event when consumer level changed
 */
export const levelChangedWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/webhooks/level-changed" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Handles Open Loyalty incoming webhook event when consumer available points amount has changed
 * Handles Open Loyalty incoming webhook event when consumer available points amount has changed
 */
export const pointsChangedWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/webhooks/points-changed" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Handles Open Loyalty incoming webhook event when consumer unit transfer has been added
 * Handles Open Loyalty incoming webhook event when consumer unit transfer has been added
 */
export const transferCreatedWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/webhooks/transfer-created" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Handles Open Loyalty incoming webhook event when consumer redeemed reward
 * Handles Open Loyalty incoming webhook event when consumer redeemed reward
 */
export const rewardRedeemedWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/webhooks/reward-redeemed" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Store Offline Campaign
 * Okta scopes for S2S authorization: offline-campaigns.write
 */
export const storeOfflineCampaign = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/offline-campaigns/campaigns" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete Offline Campaign
 * Okta scopes for S2S authorization: offline-campaigns.write
 */
export const deleteOfflineCampaign = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/offline-campaigns/campaigns/{uuid}" }, options));
};
/**
 * Get Offline Campaign
 * Okta scopes for S2S authorization: offline-campaigns.read
 */
export const getOfflineCampaign = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/offline-campaigns/campaigns/{uuid}" }, options));
};
/**
 * Update Offline Campaign
 * Okta scopes for S2S authorization: offline-campaigns.write
 */
export const updateOfflineCampaign = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/offline-campaigns/campaigns/{uuid}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Store Offline Campaign Coupon
 * Okta scopes for S2S authorization: offline-campaigns.write
 */
export const storeOfflineCampaignCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/offline-campaigns/coupons" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Delete Offline Campaign Coupon
 * Okta scopes for S2S authorization: offline-campaigns.write
 */
export const deleteOfflineCampaignCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).delete(Object.assign({ url: "/api/offline-campaigns/coupons/{uuid}" }, options));
};
/**
 * Get Offline Campaign Coupon
 * Okta scopes for S2S authorization: offline-campaigns.read
 */
export const getOfflineCampaignCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/offline-campaigns/coupons/{uuid}" }, options));
};
/**
 * Update Offline Campaign Coupon
 * Okta scopes for S2S authorization: offline-campaigns.write
 */
export const updateOfflineCampaignCoupon = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).put(Object.assign(Object.assign({ url: "/api/offline-campaigns/coupons/{uuid}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Import Offline Campaign Coupons
 * Okta scopes for S2S authorization: offline-campaigns.write
 */
export const importOfflineCampaignCoupons = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/offline-campaigns/campaigns/{uuid}/import" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Webhook to burn a coupon based on an event and source.
 * Webhook to burn a coupon based on an event and source.
 */
export const burnOfflineCampaignCouponWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/webhooks/burn-offline-campaign-coupon" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Webhook to burn a coupon when a user registered in CAS.
 * Webhook to burn a coupon when a user registered in CAS.
 */
export const casRegisterConsumerWebhook = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/webhooks/cas-register-consumer" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get user submissions
 * Get user submissions
 */
export const quizzesGetUserSubmissions = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/quizzes/by-user/{userUuid}" }, options));
};
/**
 * Store user submission
 * Store user submission
 */
export const quizzesStoreUserSubmission = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/quizzes/by-user/{userUuid}" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Get trade in public configurations
 * Get trade in public configurations
 */
export const getTradeInPublicDomainConfiguration = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/trade-in/configuration" }, options));
};
/**
 * Store new trade-in
 * Okta scopes for S2S authorization: trade-in.store
 */
export const storeTradeIn = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).post(Object.assign(Object.assign({ url: "/api/trade-in" }, options), { headers: Object.assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
/**
 * Check if consumer is eligible for trade in
 * Okta scopes for S2S authorization: trade_in
 */
export const isConsumerEligibleForTradeIn = (options) => {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : _heyApiClient).get(Object.assign({ url: "/api/trade-in/is-eligible/{uuid}" }, options));
};
//# sourceMappingURL=sdk.gen.js.map